import { EVerticalNames } from '@constants';
import { IUser } from '@sdk/contracts';
import { useTranslation } from 'react-i18next';

import { AttachFiles } from './components/AttachFiles';
import { AttachStudentFilesForManager } from './components/AttachStudentFilesForManager';
import {
  Wrapper,
  TitleWrapper,
  StepTitle,
  StepSubtitle,
  TitleText,
  Ol
} from './FpFormContent.styles';

type FpFormContentProps = {
  profile?: IUser;
  isManager: boolean;
};

export const FpFormContent: React.FC<FpFormContentProps> = ({ profile, isManager }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);

  return (
    <Wrapper>
      {isManager && <TitleText>{t(EVerticalNames.FP)}</TitleText>}
      {!isManager && (
        <TitleWrapper>
          <span>
            {t(
              'StudentProfileConfigurationTranslations:FROM_HERE_YOU_CAN_UPLOAD_YOUR_DOCUMENTATION'
            )}
          </span>
          <Ol>
            <StepTitle>
              {t('StudentProfileConfigurationTranslations:STEP_ONE_TITLE')}
              <StepSubtitle>
                {t('StudentProfileConfigurationTranslations:STEP_ONE_DESCRIPTION')}
              </StepSubtitle>
            </StepTitle>
            <StepTitle>
              {t('StudentProfileConfigurationTranslations:STEP_TWO_TITLE')}
              <StepSubtitle>
                {t('StudentProfileConfigurationTranslations:STEP_TWO_DESCRIPTION')}
              </StepSubtitle>
            </StepTitle>
            <StepTitle>
              {t('StudentProfileConfigurationTranslations:STEP_THREE_TITLE')}
              <StepSubtitle>
                {t('StudentProfileConfigurationTranslations:STEP_THREE_DESCRIPTION')}
              </StepSubtitle>
            </StepTitle>
          </Ol>
        </TitleWrapper>
      )}

      {isManager ? (
        <AttachStudentFilesForManager profile={profile} />
      ) : (
        <AttachFiles profile={profile} />
      )}
    </Wrapper>
  );
};
